import { Card, Row, Col } from 'react-bootstrap';
import { Appointment } from './types/appointment.tsx';
import { DraggableAppointment } from './DraggableAppointment';
import { DroppableCell } from './DroppableCell.tsx';
import { isSameDay, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface DayViewProps {
  currentDate: Date;
  appointments: Appointment[];
}

const timeSlots = Array.from({ length: 12 }, (_, i) => {
  const hour = i + 8;
  return `${hour.toString().padStart(2, '0')}:00`;
});

export function DayView({ currentDate, appointments }: DayViewProps) {
  const dayAppointments = appointments.filter((apt) => isSameDay(apt.date, currentDate));

  const getAppointmentsForHour = (hour: string) => {
    return dayAppointments.filter((apt) => apt.startTime.startsWith(hour.split(':')[0]));
  };

  return (
    <Card className="shadow-sm animate-fade-in overflow-hidden">
      <Card.Header className="bg-light py-3">
        <h5 className="mb-0 fw-semibold">
          {format(currentDate, "EEEE, dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
        </h5>
        <small className="text-muted">
          {dayAppointments.length} agendamento{dayAppointments.length !== 1 ? 's' : ''}
        </small>
      </Card.Header>

      <div className="schedule-scroll" style={{ maxHeight: '600px', overflowY: 'auto' }}>
        {timeSlots.map((time) => {
          const hourAppointments = getAppointmentsForHour(time);
          return (
            <DroppableCell
              key={time}
              id={`day-${format(currentDate, 'yyyy-MM-dd')}-${time}`}
              date={currentDate}
              time={time}
              className="time-slot d-flex"
            >
              <div className="time-label d-flex align-items-start justify-content-end p-2 text-muted small">
                {time}
              </div>
              <div className="flex-grow-1 p-2">
                <Row className="g-2">
                  {hourAppointments.map((apt) => (
                    <Col key={apt.id} xs={12} md={6} lg={4}>
                      <DraggableAppointment appointment={apt} />
                    </Col>
                  ))}
                </Row>
              </div>
            </DroppableCell>
          );
        })}
      </div>
    </Card>
  );
}
